import React from "react";
export function Checkmark({ size = 20, color = "#1840e3" }) {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", height: size, width: size },
        React.createElement("path", { d: "M14 4.2l-.7-.7c-.2-.2-.5-.2-.7 0l-6.7 6.7-2.5-2.5c-.2-.2-.5-.2-.7 0l-.7.8c-.2.2-.2.5 0 .7l2.5 2.5.7.7c.4.4 1 .4 1.4 0l.7-.7L14 4.9c.2-.2.2-.5 0-.7", fill: color })));
}
